import { useTheme } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import { tokens } from "../theme";
import { mockDataProjects as projectData } from "../data/mockProjectData";
import { mockBarData as data } from "../data/mockData";


const BarChart = ({ isDashboard = false }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const bdOwners = []
    projectData.forEach((item) => {
        if (!bdOwners.includes(item.bd_owner)) {
            bdOwners.push(item.bd_owner);
        }
    })
    const barData = [];
    bdOwners.forEach((i) => {

        var cold = 0;
        var extreme = 0;
        var loa = 0;
        var lost = 0;
        var new_lead = 0;
        var warm = 0;

        projectData.forEach((j) => {

            if (j.bd_owner === i) {
                if (j.status === 'Cold') {
                    cold+=Number(j.dc_capacity_mwp);
                }
                if (j.status === 'Extreme') {
                    extreme+=Number(j.dc_capacity_mwp);
                } if (j.status === 'LOA') {
                    loa+=Number(j.dc_capacity_mwp);
                } if (j.status === 'Lost') {
                    lost+=Number(j.dc_capacity_mwp);
                } if (j.status === 'new_lead') {
                    new_lead+=Number(j.dc_capacity_mwp);
                }
                if (j.status === 'Warm') {
                    warm+=Number(j.dc_capacity_mwp);
                }
            }
        })
        const itemObj = {
            BDOwner: i,
            Cold: cold.toFixed(2),
            Extreme: extreme.toFixed(2),
            LOA: loa.toFixed(2),
            Lost: lost.toFixed(2),
            NewLead: new_lead.toFixed(2),
            Warm: warm.toFixed(2)

        }
        barData.push(itemObj);

    })
    return (
        <ResponsiveBar
            data={barData}
            theme={{
                // added
                axis: {
                    domain: {
                        line: {
                            stroke: colors.grey[100],
                        },
                    },
                    legend: {
                        text: {
                            fill: colors.grey[100],
                        },
                    },
                    ticks: {
                        line: {
                            stroke: colors.grey[100],
                            strokeWidth: 1,
                        },
                        text: {
                            fill: colors.grey[100],
                        },
                    },
                },
                legends: {
                    text: {
                        fill: colors.grey[100], 
                    },
                },
                tooltip: {
                    container: {
                        background: "#ffffff",
                        color: "black",
                        fontSize: 11,
                    },
                }
            }}
            keys={["Cold","Extreme","LOA","Lost","NewLead","Warm"]}
            indexBy="BDOwner"
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            groupMode={isDashboard?"stacked":"grouped"}
            padding={0.3}
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            colors={{ scheme: "nivo" }}
            defs={[
                {
                    id: "dots",
                    type: "patternDots",
                    background: "inherit",
                    color: "#38bcb2",
                    size: 4,
                    padding: 1,
                    stagger: true,
                },
                {
                    id: "lines",
                    type: "patternLines",
                    background: "inherit",
                    color: "#eed312",
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10,
                },
            ]}
            borderColor={{
                from: "color",
                modifiers: [["darker", "1.6"]],
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: isDashboard ? undefined : "BD Owner", // changed
                legendPosition: "middle",
                legendOffset: 32,
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: isDashboard ? undefined : "value in (MWp)", // changed
                legendPosition: "middle",
                legendOffset: -40,
            }}
            enableLabel={false}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{
                from: "color",
                modifiers: [["darker", 1.6]],
            }}
            legends={[
                {
                    dataFrom: "keys",
                    anchor: "bottom-right",
                    direction: "column",
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: "left-to-right",
                    itemOpacity: 0.85,
                    symbolSize: isDashboard ? 10: 20,
                    effects: [
                        {
                            on: "hover",
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
            role="application"
            barAriaLabel={function (e) {
                return e.id + ": " + e.formattedValue + " in BdOwner: " + e.indexValue;
            }}
        />
    );
};

export default BarChart;